
import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Peripheral } from 'src/app/_model/peripheral';

@Injectable()
export abstract class PeripheralsDaoService implements Resetable {
  public abstract savePeripherals(peripherals: Peripheral[]): Promise<void>;
  public abstract getPeripherals(): Promise<Peripheral[]>;
  public abstract updateConnectionStatus(peripheral: Peripheral): Promise<void>;
  public abstract deletePeripherals(peripherals: Peripheral[]): Promise<void>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}